export const setErrorMessage = (error: any, isRegistration = false): string => {
  console.log(error);

  if (
    error?.message &&
    error?.message.includes("Account uses Google authentication")
  ) {
    return "This account uses Google sign-in. Please sign in with Google instead.";
  }

  if (isRegistration) {
    return error?.message || "Registration failed. Please try again.";
  }

  return error?.message || "Invalid email address or password.";
};
